"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sizes = require("@decisiv/design-tokens/lib/iconography/sizes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var SvgTrafficLightSlash = function SvgTrafficLightSlash(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = _objectWithoutProperties(_ref, ["size", "color"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: _sizes.alias[size],
    height: _sizes.alias[size],
    color: color,
    focusable: "false"
  }, props), _react.default.createElement("path", {
    d: "M8.502 13a1.5 1.5 0 11.001 2.999A1.5 1.5 0 018.502 13zm6.5-7a1 1 0 01.711 1.702v.001l-1.711 1.732V11h1a1 1 0 01.711 1.702v.001l-1.711 1.732V15a1 1 0 01-2 0V5.698L9.503 8.39c.304.275.499.668.499 1.11a1.5 1.5 0 01-2.535 1.082L2.735 15.68l-.006-.005A.992.992 0 012 16a1 1 0 01-1-1c0-.263.106-.499.273-.677l-.004-.003.021-.023a.027.027 0 00.005-.006l1.707-1.838V9.435L1.299 7.711A1 1 0 012 6h1.002V4.435L1.299 2.711A1 1 0 012 1h1.002a1 1 0 011-1h6a1 1 0 010 2h-5v8.298l4.116-4.433a1.5 1.5 0 11.884-1.365c0 .183-.038.355-.097.517L14.266.32l.007.006A.986.986 0 0115.002 0a1 1 0 011 1 .989.989 0 01-.273.678l.002.002-.015.017-.014.015-1.7 1.831V6h1z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};

SvgTrafficLightSlash.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_sizes.alias)),
  color: _propTypes.default.string
};
var _default = SvgTrafficLightSlash;
exports.default = _default;